export default __webpack_public_path__ + "static/media/Product-details.7da1bbb7.svg";